import React from 'react';
import logoCompact from '../../assets/images/logo.svg';
import logoFull from '../../assets/images/logo-full.svg';

const Logo = ({ size = "406", className = "", type = "full" }) => {
  const logoFile = type === "compact" ? logoCompact : logoFull;

  return (
    <img 
      src={logoFile} 
      alt="Logo" 
      width={size} 
      height={size} 
      className={className} 
    />
  );
};

export default Logo;